import { FC, useEffect, useRef } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FlashMessage: FC = () => {
  const { pathname } = useLocation();
  const [searchParameters, setSearchParameters] = useSearchParams();
  const hasShownReference = useRef(false); // flag to avoid double rendering

  useEffect(() => {
    if (hasShownReference.current) {
      return; // skip if already shown
    }
    hasShownReference.current = true;

    const flashSuccess = searchParameters.get("flashSuccess");
    const flashWarning = searchParameters.get("flashWarning");
    const flashError = searchParameters.get("flashError");

    const newParameters = new URLSearchParams(searchParameters.toString());

    const createSnackbar = (message: string, variant: "success" | "warning" | "error", parameterKey: string) => {
      const key = enqueueSnackbar(message, {
        variant,
        persist: true,
        action: () => (
          <IconButton
            onClick={() => {
              closeSnackbar(key);
              newParameters.delete(parameterKey);
              setSearchParameters(newParameters);
            }}
            size="small"
            color="inherit"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        ),
      });
    };

    if (flashSuccess != null) {
      createSnackbar(flashSuccess, "success", "flashSuccess");
    } else if (flashWarning != null) {
      createSnackbar(flashWarning, "warning", "flashWarning");
    } else if (flashError != null) {
      createSnackbar(flashError, "error", "flashError");
    }
  }, [pathname, setSearchParameters]);

  return null;
};

export default FlashMessage;
